import { render, staticRenderFns } from "./SettingAudienceAuthentication.vue?vue&type=template&id=ee9e4fea&scoped=true&"
import script from "./SettingAudienceAuthentication.vue?vue&type=script&lang=js&"
export * from "./SettingAudienceAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./SettingAudienceAuthentication.vue?vue&type=style&index=0&id=ee9e4fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9e4fea",
  null
  
)

export default component.exports